module.exports = "https://cdn2-fs.clearscore.com/flux/images/40e0f082d378a865bef90cc577a246d9.jpg";